import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { AreaType } from './types'

interface EditProps {
  area: AreaType
  communities: {
    id: string
    name: string
  }[]
}

export default function Edit({ area, communities }: EditProps) {
  return (
    <>
      <Head title="Editing area" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing area</h1>

        <Form
          area={area}
          communities={communities}
          action={`/system/areas/${area.id}`}
          method="patch"
          submitText="Update Area"
        />

        <Link
          href={`/areas/${area.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Show this area
        </Link>
        <Link
          href="/areas"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to areas
        </Link>
      </div>
    </>
  )
}
